import { TokenService } from "../services/token.service";
import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from "@angular/router";
import { FiltersTableStateService } from "../services/filters-table-state.service";
import { RoutingStatesService } from "../services/routingStates.service";
import { RoutingStates } from "../models/routingStates";
import { RoutingConstants } from "src/app/constants/routingConstants";

@Injectable({
  providedIn: "root",
})
export class ClearFiltersGuard implements CanActivate {
  private casesToKeepFilters: Map<string, string> = new Map([
    [
      RoutingConstants.certificatesMailBox.edit,
      RoutingConstants.certificatesMailBox.list,
    ],
    [
      RoutingConstants.certificatesQuery.edit,
      RoutingConstants.certificatesQuery.list,
    ],
    [
      RoutingConstants.certificatesQueryHistory.edit,
      RoutingConstants.certificatesQueryHistory.list,
    ],
    [RoutingConstants.cocMailBox.edit, RoutingConstants.cocMailBox.list],
    [RoutingConstants.cocQuery.edit, RoutingConstants.cocQuery.list],
    [
      RoutingConstants.cocQueryHistory.edit,
      RoutingConstants.cocQueryHistory.list,
    ],
    [RoutingConstants.placaMailBox.edit, RoutingConstants.placaMailBox.list],
    [RoutingConstants.placaQuery.edit, RoutingConstants.placaQuery.list],
    [
      RoutingConstants.placaQueryHistory.edit,
      RoutingConstants.placaQueryHistory.list,
    ],
  ]);

  constructor(
    private filtersTableStateService: FiltersTableStateService,
    private routingStatesService: RoutingStatesService
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    const routing = this.routingStatesService.getRoutingStates();
    const clear = this.checkClearFiltersCases(state, routing);
    if (clear) {
      const filtersEmpty = {
        filterList: [],
        filtersValuesSearch: [],
        filtersSelectorSearch: [],
      };
      this.filtersTableStateService.setPreviousValuesOfFilters(filtersEmpty);
      this.filtersTableStateService.setPreviousValuesOfFiltersOutTable(
        filtersEmpty
      );
    }
    return true;
  }

  private checkClearFiltersCases(
    state: RouterStateSnapshot,
    routing: RoutingStates
  ): boolean {
    if (routing) {
      const url = state.url.substring(1);
      const routeForward = this.casesToKeepFilters.get(routing.urlNow);
      console.log(routeForward);
      if (routeForward === url) {
        return false;
      }
    }

    return true;
  }
}
